
import { merge } from 'lodash'

import { RequestMethodsEnum ,RequestCodeEnum} from '@/enums/requestEnums'
import { Message } from "element-ui";

import store from "store";
import { getCookie } from "utils/cookie";

const baseUrl = process.env.VUE_APP_BASE_API
const timeout = 20000
const urlPrefix = 'api'
import { Axios } from './axios'

// 处理axios的钩子函数
const axiosHooks = {
  requestInterceptorsHook(config) {
    const { isParamsToData } = config.requestOptions
    const params = config.params || {}
    const headers = config.headers || {}

    // 添加token
    if (getCookie("token")) {
      config.headers["token"] = getCookie("token");
    }
    console.log(config, 'config')
    // POST请求下如果无data，则将params视为data
    if (
      isParamsToData &&
      !Reflect.has(config, 'data') &&
      config.method?.toUpperCase() === RequestMethodsEnum.POST
    ) {
      config.data = params
      config.params = {}
    }
    config.headers = headers
    // config.url = config.url?.replace(".", "/")
    return config
  },
  requestInterceptorsCatchHook(err) {
    return err
  },
  async responseInterceptorsHook(response) {
    console.log(response,'responseresponseresponseresponseresponse123465468798');
    const { isTransformResponse, isReturnDefaultResponse } = response.config.requestOptions

    //返回默认响应，当需要获取响应头及其他数据时可使用
    if (isReturnDefaultResponse) {
      return response
    }
    // 是否需要对数据进行处理
    if (!isTransformResponse) {
      return response.data
    }
    const { code, data, show, msg } = response.data
    switch (code) {
      case RequestCodeEnum.SUCCESS:
        if (show) {
          msg && Message.success(msg)
        }
        return data
      case RequestCodeEnum.FAIL:
        if (show) {
          msg && Message.error(msg)
        }
        return Promise.reject(data)
      case RequestCodeEnum.LOGIN_FAILURE:
        
        return Promise.reject()
      case RequestCodeEnum.OPEN_NEW_PAGE:
        window.location.href = data.url
        return data
      default:
        return data
    }
  },
  responseInterceptorsCatchHook(error) {
    console.log(error,'errorerror')
    // if (error.code !== AxiosError.ERR_CANCELED) {
    //   error.message && Message.error(error.message)
    // }
    return Promise.reject(error)
  }
}

const defaultOptions = {
  //接口超时时间
  timeout: timeout || 20000,
  // 基础接口地址
  baseURL: baseUrl,
  //请求头
  headers: { 'Content-Type': 'application/json;charset=UTF-8' },
  // 处理 axios的钩子函数
  axiosHooks: axiosHooks,
  // 每个接口可以单独配置
  requestOptions: {
    // 是否将params视为data参数，仅限post请求
    isParamsToData: true,
    //是否返回默认的响应
    isReturnDefaultResponse: false,
    // 需要对返回数据进行处理
    isTransformResponse: false,
    // 接口拼接地址
    urlPrefix: urlPrefix,
    // 忽略重复请求
    ignoreCancelToken: false,
    // 是否携带token
    withToken: true,
    // 开启请求超时重新发起请求请求机制
    isOpenRetry: true,
    // 重新请求次数
    retryCount: 2
  }
}

function createAxios(opt) {
  return new Axios(
    // 深度合并
    merge(defaultOptions, opt || {})
  )
}
const request = createAxios()
export default request 